import { ICON_DEFAULT_FOREGROUND_COLOR } from '../../../graphConstants';
import { makeTag } from '../../../svg/utils';
import {
  type NodeIconOptions,
  type NodeTypeIcon,
  nodeIconDefaultOptions,
} from '../NodeTypeIcon';
import { createSquareNodeTypeIcon, wrapNodeIconInSvgTag } from '../common';
import { drawSquareBackground } from '../drawIconBackground';

const ICON_SIZE = 40;
const FEX_GLYPH_PADDING = 5.2;
const FEX_LINE_POSITIONS = [10.4, 20, 29.6];

const fexDefaultOptions = {
  ...nodeIconDefaultOptions,
  style: { background: 'gray' },
} satisfies Partial<NodeIconOptions>;

function createFexIcon(options: NodeIconOptions = {}): string {
  const opts = { ...fexDefaultOptions, ...options };

  const drawFexLine = (x1: number, y1: number, x2: number, y2: number) =>
    makeTag('line', {
      x1,
      y1,
      x2,
      y2,
      stroke: ICON_DEFAULT_FOREGROUND_COLOR,
      'stroke-width': 1.4,
    });
  const drawHorizontalFexLine = (y: number) =>
    drawFexLine(FEX_GLYPH_PADDING, y, ICON_SIZE - FEX_GLYPH_PADDING, y);
  const drawVerticalFexLine = (x: number) =>
    drawFexLine(x, FEX_GLYPH_PADDING, x, ICON_SIZE - FEX_GLYPH_PADDING);

  const drawFexCircle = (cx: number, cy: number) =>
    makeTag('circle', {
      cx,
      cy,
      fill: ICON_DEFAULT_FOREGROUND_COLOR,
      r: 3,
    });

  const icon = `
    ${drawSquareBackground(ICON_SIZE, opts.style)}
    ${FEX_LINE_POSITIONS.map(drawHorizontalFexLine).join()}
    ${FEX_LINE_POSITIONS.map(drawVerticalFexLine).join()}
    ${FEX_LINE_POSITIONS.map((x) =>
      FEX_LINE_POSITIONS.map((y) => drawFexCircle(x, y)).join(''),
    ).join('')}
  `;

  return wrapNodeIconInSvgTag(icon, ICON_SIZE, ICON_SIZE, 'topLeft', opts);
}

export const fexIcon: NodeTypeIcon = createSquareNodeTypeIcon(
  ICON_SIZE,
  createFexIcon,
);
